import { render, staticRenderFns } from "./UpdateText.vue?vue&type=template&id=410dfbc1&scoped=true"
import script from "./UpdateText.vue?vue&type=script&lang=ts"
export * from "./UpdateText.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./UpdateText.vue?vue&type=style&index=0&id=410dfbc1&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "410dfbc1",
  "0281b900"
  
)

export default component.exports